// extracted by mini-css-extract-plugin
export var parcelRow = "_ts-0";